/**
 * Splits a `ts_headline` snippet into plain and matched runs.
 *
 * The server marks matches with `<<` and `>>` rather than emitting HTML, and that choice is the
 * reason this function exists: shipping markup from the database straight into a browser is how an
 * injection happens, so the markers are parsed here and turned into React elements. Nothing in this
 * path ever reaches `dangerouslySetInnerHTML`.
 *
 * Pure and separately tested for the bug-070 reason: that defect lived in exactly this kind of
 * small rendering helper — `collapse.ts` — where it was invisible to every integration test because
 * the data reaching it looked fine.
 */
export interface SnippetPart {
  text: string
  match: boolean
}

export function splitHighlights(snippet: string): SnippetPart[] {
  const parts: SnippetPart[] = []
  // Non-greedy, so two matches in one snippet do not swallow the text between them.
  const pattern = /<<(.*?)>>/gs
  let cursor = 0

  for (const found of snippet.matchAll(pattern)) {
    const at = found.index
    if (at > cursor) parts.push({ text: snippet.slice(cursor, at), match: false })
    parts.push({ text: found[1] ?? '', match: true })
    cursor = at + found[0].length
  }
  if (cursor < snippet.length) parts.push({ text: snippet.slice(cursor), match: false })

  return parts
}
